module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-4.ad7e36aa.mp3";